import styled from 'styled-components';
import { HTMLContainer } from './HtmlZone.style';

interface ConsentsContainerProps {
  disabled?: boolean;
}

export const ConsentsContainer = styled(HTMLContainer)<ConsentsContainerProps>`
  flex-direction: column;
  top: auto;
  bottom: 26vh;
  height: 17vh;
  overflow-y: scroll;
  padding-top: 1vh;
  padding-bottom: 1vh;
  justify-content: flex-start;
  ${({ disabled }): string => {
    return disabled === true
      ? 'opacity: 0.2;'
      : '';
  }}

  &::-webkit-scrollbar {
    width: 1vw;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #bdbdbd;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbd;
  }
`;
ConsentsContainer.displayName = 'ConsentsContainer';

export const CollectOptin = styled.div`
`;
CollectOptin.displayName = 'CollectOptin';
